import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Form, Button, Col, Row, Container } from "react-bootstrap";
import { useStateValue } from "../../context";
import { verifyPassword } from "../../context/fetch/fetchUser";
import schema from "./schema";

const VerifyPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const [{ user }, dispatch] = useStateValue();
  const verifyPasswordLoading = user.verifyPasswordLoading;

  const [state, setState] = useState({
    fields: { oldPassword: "", password: "", confirmPassword: "" },
    errors: { oldPassword: "", password: "", confirmPassword: "" },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    schema
      .validate(state.fields, { abortEarly: false })
      .then(() => {
        const data = {
          password: state.fields.password,
          token: token,
        };
        verifyPassword(data, dispatch, navigate);
      })
      .catch((err) => {
        const newState = {
          errors: { oldPassword: "", password: "", confirmPassword: "" },
        };
        err.errors.forEach((err) => {
          newState.errors[err.key] = err.value;
        });
        setState({ ...state, ...newState });
      });
  };
  const onChange = (e) => {
    const { name, value } = e.target;
    setState({
      ...state,
      fields: { ...state.fields, [name]: value },
      errors: { ...state.errors, [name]: "" },
    });
  };

  return (
    <Container className={"login-container"}>
      <Row className={"justify-content-center"}>
        <Col md={7} lg={6} xl={5}>
          <Form onSubmit={handleSubmit} className={"login-box m-auto"}>
            <p className={"text-center text-uppercase login-title fbold"}>{"Reset Password"}</p>
            <Form.Group className="form-group mb-4">
              <Form.Control
                type="password"
                name="password"
                placeholder="New password"
                id="password"
                onChange={onChange}
                value={state.fields.password}
                className={"focus-effect cursor-pointer"}
              />
              <span className={"focus-border"}></span>
              {!!state.errors.password && (
                <Form.Text className="text-danger">{state.errors.password}</Form.Text>
              )}
            </Form.Group>
            <Form.Group className="form-group mb-4">
              <Form.Control
                type="password"
                name="confirmPassword"
                placeholder="Confirm new Password"
                value={state.fields.confirmPassword}
                onChange={onChange}
                id="confirmPassword"
                className={"focus-effect cursor-pointer"}
              />
              <span className={"focus-border"}></span>
              {!!state.errors.confirmPassword && (
                <Form.Text className="text-danger">{state.errors.confirmPassword}</Form.Text>
              )}
            </Form.Group>
            <p className={"text-center mb-0"}>
              <Button type="submit" disabled={verifyPasswordLoading}>
                {verifyPasswordLoading ? "Loading" : "Change Password"}
              </Button>
            </p>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default VerifyPassword;
